import { Component, OnInit, EventEmitter, Output, ViewChild, ViewContainerRef, ComponentFactoryResolver, ViewChildren, QueryList, ComponentFactory } from "@angular/core";
import { IPublisherSettingsModel } from "./publisher.model";
import { PublisherSettingsFormComponent } from "./publisher-settings-modal-form.component";
import { DropdownValue } from "../shared/dropdown.model";
import { Validators } from "@angular/forms";

@Component({
    selector: 'publisher-settings-modal',
    moduleId: module.id,
    templateUrl: 'publisher-settings-modal.component.html'
})

export class PublisherSettingsComponent {
    sectionCounter: number = 1;
    sectionsAreValid: boolean = true;
    deviceTypeValues: Array<DropdownValue> = [];

    @ViewChild('dynamicInsert', { read: ViewContainerRef }) parent: ViewContainerRef;
    componentFactory: ComponentFactory<PublisherSettingsFormComponent>;
    settingComponents: PublisherSettingsFormComponent[];

    @Output()
    public publisherSettings: EventEmitter<IPublisherSettingsModel[]> = new EventEmitter<IPublisherSettingsModel[]>();

    constructor(private componentFactoryResolver: ComponentFactoryResolver) {
        this.settingComponents = new Array<PublisherSettingsFormComponent>();
    }

    ngOnInit() {
        this.componentFactory = this.componentFactoryResolver.resolveComponentFactory(PublisherSettingsFormComponent);

        this.deviceTypeValues.push(new DropdownValue(1, 'Android'));
        this.deviceTypeValues.push(new DropdownValue(2, 'IOS'));
        this.deviceTypeValues.push(new DropdownValue(10, 'Other'));

        setInterval(() => {
            this.sectionsAreValid = true;
            this.settingComponents.forEach(c => {
                if (c.publisherSettingsForm != undefined && c.publisherSettingsForm.valid == false)
                    this.sectionsAreValid = false;
            });
        }, 300);
    }

    ngAfterViewInit() {
        this.parent.clear();
        this.addFormComponent();
    }

    addSection() {
        this.addFormComponent();
        this.sectionCounter++;
    }

    private addFormComponent() {
        let c = this.parent.createComponent(this.componentFactory);
        c.instance.removedPublisherSetting.subscribe($event => {
            this.removePublisherSettings($event);
        });
        let notYetSelectedDeviceTypes = this.deviceTypeValues.map(x => Object.assign({}, x));
        for (let j = 0; j < this.deviceTypeValues.length; j++) {
            for (let i = 0; i < this.settingComponents.length; i++)
                if (this.settingComponents[i].publisherSettingsForm.value.deviceTypeField == this.deviceTypeValues[j].value) {
                    let index = notYetSelectedDeviceTypes.findIndex(x => x.value == this.deviceTypeValues[j].value);
                    notYetSelectedDeviceTypes.splice(index, 1);
                }
        }
        c.instance.deviceTypeValues = notYetSelectedDeviceTypes;
        this.settingComponents.push(c.instance);
    }

    removePublisherSettings(item) {
        let index = this.settingComponents.findIndex(x => x.publisherSettingsForm.value.deviceTypeField == item);
        if (index > -1) {
            this.parent.remove(index);
            this.settingComponents.splice(index, 1);
            this.sectionCounter--;
        }
    }

    onPrevious($event) {
        $('#publisherSettingsModal').modal('hide');
        $('#publisherInfoModal').modal('show');
    }

    onNext(event) {
        if (this.sectionsAreValid == true) {
            let result = new Array<IPublisherSettingsModel>();
            this.settingComponents.forEach(c => {
                let r1 = new IPublisherSettingsModel();
                r1.bundleId = c.publisherSettingsForm.value.bundleIdField;
                r1.deviceType = c.publisherSettingsForm.value.deviceTypeField;
                r1.isRefundingCredit = c.publisherSettingsForm.value.isRefundingCreditField;
                r1.showCreditNotification = c.publisherSettingsForm.value.showCreditNotificationField;
                r1.url = c.publisherSettingsForm.value.urlField;
                r1.version = c.publisherSettingsForm.value.versionField;
                result.push(r1);
            });
            this.publisherSettings.emit(result);
            $('#publisherSettingsModal').modal('hide');
        } else {
            //show error messages
        }
    }

    clearModal() {
        this.settingComponents = [];
        this.parent.clear();
        this.addFormComponent();
        this.sectionCounter = 1;
    }
}


// WEBPACK FOOTER //
// ./src/app/publishers/publisher-settings-modal.component.ts